import {Component}       from '@angular/core';
import {Router} from '@angular/router';
import {DataTableDirectives} from 'angular2-datatable/datatable';
import {FORM_DIRECTIVES, FORM_PROVIDERS, REACTIVE_FORM_DIRECTIVES, FormControl, FormGroup} from '@angular/forms';
import {AlertComponent} from 'ng2-bootstrap/ng2-bootstrap';
import {MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from 'ng2-bootstrap/ng2-bootstrap';
import {PaginatePipe, PaginationControlsCmp, PaginationService} from 'ng2-pagination';

import {BankService}     from '../../service/bank.service';
import {Bank} from '../../domain/bank';
import {Page} from '../../domain/page';

@Component({
    selector: 'config-banks',
    template: require('./config.banks.component.html'),
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        PaginationControlsCmp
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [PaginatePipe],
})
export class ConfigBanksComponent {

    private data:Bank[];

    private filter:string;

    public error:any;

    private currentPage:Page;

    public form:FormGroup;

    public itemsPerPage:number;
    public loading:boolean;
    public page:number;
    public total:number;

    public bankSelected:Bank;

    constructor(private router:Router,
                private banksService:BankService) {
        this.init();

        this.form.valueChanges
            .debounceTime(400)
            .subscribe(this.find.bind(this));

        /*Default: mostrar todos los bancos*/
        this.find();
    }

    private init():void {
        this.data = [];
        this.filter = "";

        this.form = new FormGroup({
            search: new FormControl(),
            itemsPerPage: new FormControl()
        });

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;
    }

    private find():void {
        this.getData(1);
    }

    private getData(page:number):void {
        this.error = null;
        if (this.itemsPerPage != null && this.itemsPerPage > 0) {
            if (this.filter) {
                this.loading = true;
                this.banksService.findBanks(this.filter, page, this.itemsPerPage)
                    .subscribe((data) => {
                            this.refreshData(data);
                            this.page = page;
                        },
                        () => {
                            this.bindError('Ocurrió un error al buscar los bancos.');
                        });
            } else {
                this.banksService.listBanks(page, this.itemsPerPage)
                    .subscribe((data) => {
                            this.refreshData(data);
                            this.page = page;
                        },
                        () => {
                            this.bindError('Ocurrió un error al listar los bancos.');
                        });
            }
        } else {
            this.bindError('Cantidad de ítems no válida.');
        }
    }

    private refreshData(page:Page):void {
        this.data = page.content.map(bank => new Bank(bank));
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public removeBank(deleteModal:any):void {
        this.error = null;
        this.banksService.delete(this.bankSelected.id)
            .subscribe(() => {
                    deleteModal.hide();
                    this.removeBankFromView(this.bankSelected);
                },
                () => {
                    this.bindError('Ocurrió un error al eliminar el banco.');
                });
    }

    private removeBankFromView(bank:Bank):void {
        let index = this.data.indexOf(bank);
        if (index > -1) {
            this.data.splice(index, 1);
        }
        this.bankSelected = null;
    }

    public editBank(bank:Bank):void {
        this.router.navigate(['app/home/config/editBank', bank.id]);
    }

    public createBank():void {
        this.router.navigate(['app/home/config/createBank']);
    }

    public getPage(page:number):void {
        this.getData(page);
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/banks/config.banks.component.ts
 **/